













import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseButton from '@/components/buttons/BaseButton.vue';

@Component({
	components: {
		BaseButton,
	},
})
export default class HeaderButton extends Vue {
	@Prop() private icon!: string;

	@Prop() private eventName!: string;

	@Prop() private message: string | undefined;
}
